import { projectApi } from "@/services";
import store from "../../store";
import { $config } from "../../conf";

export let interactionAPI = {
  /**
   * 记录任务行为
   * @param taskId 任务id
   * @param objectId 触发任务的对象id
   * @returns {*}
   */
  logAdd({ taskId, objectId }) {
    return projectApi.request("/custom/task-log/add", {
      sess: store.state.userInfo.token.smarketToken,
      activityId: $config.activityId,
      tenantId: 519,
      taskId,
      objectId,
    });
  },

  /**
   * 完成全局互动任务
   * @param taskId 任务id
   * @param objectId 触发任务的对象id
   * @returns {*}
   */
  onInteractionTaskComplete({ taskId, objectId, batchId }) {
    return projectApi.request("/custom/task/complete", {
      sess: store.state.userInfo.token.smarketToken,
      activityId: $config.activityId,
      tenantId: 519,
      taskId,
      objectId,
      batchId,
    });
  },

  /**
   * 获取完成的全局互动任务
   * @param sess
   * @param activityId 活动id
   * @returns {*}
   */
  onInteractionMyTaskComplete() {
    return projectApi.request("/interaction/custom/task/completed", {
      sess: store.state.userInfo.token.smarketToken,
      activityId: $config.activityId,
      tenantId: 519,
    });
  },
};
